import React from 'react'

import BeatLoader from "react-spinners/BeatLoader";

const override = {

};

const BeatLoading = ({ loading, color, size }) => {
  return (
    <div className="sweet-loading">
      <BeatLoader
        color={color}
        loading={loading}
        cssOverride={override}
        size={size}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  )
}

export default BeatLoading